import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

// Preferred icon for AI-related features going forward - a magic wand, distinct from the
// letterform-based AIIcon already used elsewhere in the app (kept as-is, not retrofitted).
export const WandIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <path d="m20 7-.95-2.05L17 4l2.05-.95L20 1l.95 2.05L23 4l-2.05.95Z" />
            <path d="M8.5 7l-.95-2.05L5.5 4l2.05-.95L8.5 1l.95 2.05L11.5 4l-2.05.95Z" />
            <path d="M20 18.5l-.95-2.05L17 15.5l2.05-.95.95-2.05.95 2.05 2.05.95-2.05.95Z" />
            <path d="M5.1 21.7l-2.8-2.8q-.3-.3-.3-.725t.3-.725L13.45 6.3q.3-.3.725-.3t.725.3l2.8 2.8q.3.3.3.725t-.3.725L6.55 21.7q-.3.3-.725.3t-.725-.3Zm.75-2.1L13 12.4 11.6 11l-7.2 7.15Z" />
        </SvgIcon>
    );
};
